export const SPACING: number = 4;

export const BREAKPOINTS = {
  xs: 400,
  sm: 840,
  md: 1080,
  lg: 1280,
  xl: 1440,
};
